import { render } from "@testing-library/react";
import React, { Suspense, useContext, useEffect } from "react";
import { useState } from "react";

import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import $ from "jquery";
import {
  assessmentFetchPeriodList,
  GetEmpAssessmentPeriodList,
} from "./PMSService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
const HrAssessment = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [EmpAssessmentList, setEmpAssessmentList] = useState([]);
  const [EmpAssessmentListCount, setEmpAssessmentListCount] = useState([]);
  const toster = useContext(TostMsg);
  const [assessmentfetchPeriod, setAssessmentfetchPeriod] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  useEffect(() => {
    getEmpAssessmentPeriodList();
  }, []);


  async function getEmpAssessmentPeriodList() {
    setLoading(true);
    const body = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      OAPGuId: "",
      Search: "",
      PageNumber: 1,
      PageSize: 1000,
    };
    try {
      let LikeList = await GetEmpAssessmentPeriodList(body);
      setEmpAssessmentListCount(LikeList?.Data);
      setEmpAssessmentList(LikeList?.Data?.assessmentPresiodResponse);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST?.EmpAssessmentList);
    }
  }

  const myFunction = () => {
    var x = document.getElementById("myDIV2");
    if (x.style.display === "block") {
      x.style.display = "none";
    } else {
      x.style.display = "block";
    }
  };

  const showPopup = () => {
    $(".Show-upload-div").click(function () {
      $(".upload-img").show("slow");
    });
    $(".Hide-upload-div").click(function () {
      $(".upload-img").hide("slow");
    });
  };
  const ShowUploadDiv2 = () => {
    $(".Show-upload-div2").click(function () {
      $(".upload-emoji").show("slow");
    });
    $(".Hide-upload-div2").click(function () {
      $(".upload-emoji").hide("slow");
    });
  };

  const navigateToDetailPage = (guid) => {
    history.push(`/Assessment/Cycle/Details/${guid}`)
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Assessment Cycles</h2>
              </div>
              <div className="rightside-tabs">
                <Link to="/Assessment/Employee/Cycles">
                  <button
                    className="add-newticket w-auto float-right"
                    style={{ minWidth: "fit-content" }}
                  >
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg> */}
                    Employee Dashboard
                  </button>
                </Link>
                <Link to="/Assessment/AddAssessment">
                  <button
                    className="add-newticket w-auto float-right"
                    style={{ minWidth: "fit-content" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                    New Assessment
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="tickets-summary">
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Avg Employee Tenure</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      {/* <span className="dark-inverted">00</span> */}
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalPeriodCount}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Current</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Per Cycle</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      {/* <span className="dark-inverted">10</span> */}
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalPeriodCount}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Avg. Duration</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Self Review</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      {/* <span className="dark-inverted">15</span> */}
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalPeriodCount}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Avg. Duration</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Manager Review</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      {/* <span className="dark-inverted">12</span> */}
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalPeriodCount}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Avg. Duration</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Senior Level Review</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      {/* <span className="dark-inverted">08</span> */}
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalPeriodCount}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Avg. Duration</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Avg. Rating</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      {/* <span className="dark-inverted">05</span> */}
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalPeriodCount}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Current</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/* .filter(
              (el) => el?.GroupByStatus == "Open"
            ) */}
          <div className="col-xl-9">
            {EmpAssessmentList?.map((el, index) => (
              <div key={index}>
                <p className="status-category">{el?.GroupByStatus}</p>
                <div className="assessment-block">
                  <div className="illustration-header00">
                    <div className="header-meta">
                      <div className="first-divblock">
                        <div>
                          <h3>
                            FY {moment(el?.From).format("YY")}-
                            {moment(el?.To).format("YY")}{" "}
                            {el?.Title}
                          </h3>
                          <ul className="basicinfomation">
                            <li>
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              ></i>
                              {moment(el?.StartedOn).format("MMM DD YYYY")} -{" "}
                              {moment(el?.EndedOn).format("MMM DD YYYY")}
                            </li>{" "}
                            <li>
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                              Total Employee :{" "}
                              <b className="emp-count">
                                {el?.TotalEligibleEmployees}
                              </b>
                            </li>
                          </ul>
                        </div>
                        <div className="ml-auto">
                          <span className="assessment-status-initiated">
                            {el?.AssessmentPeriodStatus}

                            </span>

                          <span
                            className="assessment-view-detail"
                            onClick={() => navigateToDetailPage(el?.GUID)}
                          >
                            View Detail
                          </span>

                        </div>
                      </div>
                      <div className="summary-stats">
                        <div className="summary-stat">
                          <img src="images/pms/start-date.svg" />
                          <div>
                            <span>Initiated On</span>
                            <span>
                              {moment(el?.StartedOn).format("MMM DD YYYY")}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/start-date.svg" />
                          <div>
                            <span>Self Assessment By</span>
                            <span>
                              {moment(el?.SelfAssesmentClosureDate).format(
                                "MMM DD YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/end-date.svg" />
                          <div>
                            <span>First Review By</span>
                            <span>
                              {moment(el?.FirstReviewerClosureDate).format(
                                "MMM DD YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/date.svg" />
                          <div>
                            <span>Assessment Closure By</span>
                            <span>
                              {moment(el?.EndedOn).format("MMM DD YYYY")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-xl-3">
            <p className="status-category">Process</p>
            <OwlCarousel
              loop
              margin={10}
              // nav
              items={1}
              autoplay={true}
              autoplayTimeout={3000}
              autoplayHoverPause={true}
            >
              <div className="review-step">
                <span>01</span>
                <img
                  src="https://huro.cssninja.io/assets/img/illustrations/widgets/1.svg"
                  style={{ width: "160px", margin: "auto auto 20px" }}
                />
                <h4>Goal Setting</h4>
                <p>
                  Every start of year, set some goals for yourself. Progress is
                  generally good when you follow a goal
                </p>
              </div>
              <div className="review-step">
                <span>02</span>
                <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/7.svg" />
                <h4>Self Assessment</h4>
                <p>
                  Once review process is started, List down all your success and
                  failures, all good and bad and rate yourself
                </p>
              </div>
              <div className="review-step">
                <span>03</span>
                <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/8.svg" />
                <h4>Manager Assessment</h4>
                <p>
                  It is managers duty to review your performance without any
                  prejudice. It should be based on actual outcomes of your
                  efforts
                </p>
              </div>
              <div className="review-step">
                <span>04</span>
                <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/4.svg" />
                <h4>Recomendation</h4>
                <p>
                  Based on your review and your managers assessment, senior
                  management may recommend you new goals, role and
                  responsibilities
                </p>
              </div>
              <div className="review-step">
                <span>05</span>
                <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/7.svg" />
                <h4>One-on-One meeting</h4>
                <p>
                  Use this to discuss all your doubts and chalk out the startegy
                  to do better this year
                </p>
              </div>
            </OwlCarousel>
          </div>
          {/* <div className="col-xl-9">
            {EmpAssessmentList?.filter(
              (el) => el?.GroupByStatus == "Close"
            ).map((el, index) => (
              <div key={index}>
                <p className="status-category">{el?.GroupByStatus}</p>
                <div className="assessment-block">
                  <div className="illustration-header00">
                    <div className="header-meta">
                      <div className="first-divblock">
                        <div>
                          <h3>
                            FY {moment(el?.From).format("YY")}-
                            {moment(el?.To).format("YY")}{" "}
                            {el?.AssesmentTemplateName}
                          </h3>
                          <ul className="basicinfomation">
                            <li>
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              ></i>
                              {moment(el?.StartedOn).format("MMM DD YYYY")} -{" "}
                              {moment(el?.ReviewEndDate).format("MMM DD YYYY")}
                            </li>{" "}
                            <li>
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                              Total Employee :{" "}
                              <b className="emp-count">
                                {el?.TotalEligibleEmployees}
                              </b>
                            </li>
                          </ul>
                        </div>
                        <div className="ml-auto">
                          <span className="assessment-status-initiated">
                            {el?.AssessmentPeriodStatus}
                          </span>
                          <span
                            className="assessment-view-detail"
                            onClick={() => navigateToDetailPage(el?.GUID)}
                          >
                            View Detail
                          </span>
                        </div>
                      </div>
                      <div className="summary-stats">
                        <div className="summary-stat">
                          <img src="images/pms/start-date.svg" />
                          <div>
                            <span>Initiated On</span>
                            <span>
                              {moment(el?.StartedOn).format("MMM DD YYYY")}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/start-date.svg" />
                          <div>
                            <span>Self Assessment By</span>
                            <span>
                              {moment(el?.SelfAssesmentClosureDate).format(
                                "MMM DD YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/end-date.svg" />
                          <div>
                            <span>First Review By</span>
                            <span>
                              {moment(el?.FirstReviewerClosureDate).format(
                                "MMM DD YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/date.svg" />
                          <div>
                            <span>Assessment Closure By</span>
                            <span>
                              {moment(el?.EndedOn).format("MMM DD YYYY")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div> */}

          {/* <div className="col-xl-9">
            <p className="status-category">In Progress</p>
            {EmpAssessmentList?.filter(
              (el, index) => el?.AssessmentPeriodStatus == "In Progress"
            ).map((el, index) => (
              <div key={index}>
                <div className="assessment-block">
                  <div className="illustration-header00">
                    <div className="header-meta">
                      <div className="first-divblock">
                        <div>
                          <h3>
                            FY {moment(el?.From).format("YY")}-
                            {moment(el?.To).format("YY")}{" "}
                            {el?.AssesmentTemplateName}
                          </h3>
                          <ul className="basicinfomation">
                            <li>
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              ></i>
                              {moment(el?.StartedOn).format("MMM DD YYYY")} -{" "}
                              {moment(el?.ReviewEndDate).format("MMM DD YYYY")}
                            </li>{" "}
                            <li>
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                              Total Employee :{" "}
                              <b className="emp-count">
                                {el?.TotalEligibleEmployees}
                              </b>
                            </li>
                          </ul>
                        </div>
                        <div className="ml-auto">
                          <span className="assessment-status-initiated">
                            {el?.AssessmentPeriodStatus}
                          </span>
                          <span
                            className="assessment-view-detail"
                            onClick={() => navigatePage(el?.GUID)}
                          >
                            View Detail
                          </span>
                        </div>
                      </div>
                      <div className="summary-stats">
                        <div className="summary-stat">
                          <img src="images/pms/start-date.svg" />
                          <div>
                            <span>Initiated On</span>
                            <span>
                              {moment(el?.StartedOn).format("MMM DD YYYY")}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/start-date.svg" />
                          <div>
                            <span>Self Assessment By</span>
                            <span>
                              {moment(el?.SelfAssesmentClosureDate).format(
                                "MMM DD YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/end-date.svg" />
                          <div>
                            <span>First Review By</span>
                            <span>
                              {moment(el?.FirstReviewerClosureDate).format(
                                "MMM DD YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/date.svg" />
                          <div>
                            <span>Assessment Closure By</span>
                            <span>
                              {moment(el?.EndedOn).format("MMM DD YYYY")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="col-xl-9">
            <p className="status-category">Completed</p>
            {EmpAssessmentList?.filter(
              (el) => el?.AssessmentPeriodStatus == "Completed"
            ).map((el, index) => (
              <div key={index}>
                <div className="assessment-block">
                  <div className="illustration-header00">
                    <div className="header-meta">
                      <div className="first-divblock">
                        <div>
                          <h3>
                            FY {moment(el?.From).format("YY")}-
                            {moment(el?.To).format("YY")}{" "}
                            {el?.AssesmentTemplateName}
                          </h3>
                          <ul className="basicinfomation">
                            <li>
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              ></i>
                              {moment(el?.StartedOn).format("MMM DD YYYY")} -{" "}
                              {moment(el?.ReviewEndDate).format("MMM DD YYYY")}
                            </li>
                            <li>
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                              Total Employee :{" "}
                              <b className="emp-count">
                                {el?.TotalEligibleEmployees}
                              </b>
                            </li>
                          </ul>
                        </div>
                        <div className="ml-auto">
                          <span className="assessment-status-initiated">
                            {el?.AssessmentPeriodStatus}
                          </span>
                          <span
                            className="assessment-view-detail"
                            onClick={() => navigatePage(el?.GUID)}
                          >
                            View Detail
                          </span>
                        </div>
                      </div>
                      <div className="summary-stats">
                        <div className="summary-stat">
                          <img src="images/pms/start-date.svg" />
                          <div>
                            <span>Initiated On</span>
                            <span>
                              {moment(el?.StartedOn).format("MMM DD YYYY")}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/start-date.svg" />
                          <div>
                            <span>Self Assessment By</span>
                            <span>
                              {moment(el?.SelfAssesmentClosureDate).format(
                                "MMM DD YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/end-date.svg" />
                          <div>
                            <span>First Review By</span>
                            <span>
                              {moment(el?.FirstReviewerClosureDate).format(
                                "MMM DD YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="summary-stat">
                          <img src="images/pms/date.svg" />
                          <div>
                            <span>Assessment Closure By</span>
                            <span>
                              {moment(el?.EndedOn).format("MMM DD YYYY")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div> */}

          <div className="col-xl-12">
            <strong className="assessment-title">Eligible Employees</strong>
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-4">
                  <div className="me-auto w-50">
                    <input
                      type="text"
                      placeholder="search..."
                      className="form-control"
                      style={{ height: "41px" }}
                    />
                  </div>
                  <div className="saving-btn00">
                    <button
                      className="add-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Add"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                        />
                      </svg>
                    </button>
                    <button
                      className="update-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Update"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                      </svg>
                    </button>
                    <button
                      className="remove-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remove"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                      </svg>
                    </button>
                    <button
                      className="import-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Import"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="export-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Export"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-up"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="assign-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Assign"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-clipboard-check"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                        />
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="employee-card tile-grid tile-grid-v1">
                    <div className="table-responsive emp-table">
                      {/* dataTable no-footer */}
                      <table
                        id="example"
                        className="table table-striped table-bordered dataTable no-footer"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "50px" }}>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="checkAll"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="checkAll"
                                ></label>
                              </div>
                            </th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Assigned To</th>
                            <th>Score</th>
                            <th>Rating</th>
                            <th>Rating Scale</th>
                            <th>First Reviewer</th>
                            <th>Second Reviewer</th>
                            <th>HR</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/6.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Savita Rana
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Closed</td>
                            <td>
                              Arun Mishra
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Vital Performance</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="even">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/8.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">Sonal</span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/1.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Anubhav Singh
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="even">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>

                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/2.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Dharmesh tyagi
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/3.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">Rashika</span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add-new-assessment">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <img src="images/pms/new-assess.gif" />
              <strong className="modal-title text-center d-block">
                Start New Assessment
              </strong>
              <p className=" text-center d-block">
                Do you really want to Report this post ?
              </p>
              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Review By</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assessment Period Start</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assessment Period End</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assessment Start</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assessment End</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Self Assessment Last Date</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>First Reviewer Last Date</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default HrAssessment;
